import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { AppService } from '../../../services';

@Injectable()
export class LastUsedService {
  private http = inject(HttpClient);
  private _appService = inject(AppService);


  private headers = new HttpHeaders();
  private templateUrl = this._appService.getServerBaseUrl + '/template';

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {

    this.headers.append("Accept", "*/*")
    this.headers.append("Content-Type", "application/json")
  }

  getLastUsed(): Observable<any> {
    const url = `${this.templateUrl}/lastused`;
    let options = { headers: this.headers, withCredentials: true };
    return this.http.get(url, options)
  }
}
